import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ChatbotMessageRequest, ChatbotMessageResponse } from '../../models/chatbot.models';

@Injectable({
  providedIn: 'root'
})
export class ChatbotService {
  private readonly apiUrl = `${environment.apiUrl}/chatbot/message/`;

  constructor(private httpClient: HttpClient) {}

  sendMessage(payload: ChatbotMessageRequest): Observable<ChatbotMessageResponse> {
    return this.httpClient.post<ChatbotMessageResponse>(this.apiUrl, payload).pipe(
      catchError(error => throwError(() => error))
    );
  }
}
